module.exports = __webpack_public_path__ + "static/media/ic-preferences.90bb98ba.svg";